import { ReactNode } from 'react';
import Link from 'next/link';
import { getParsedHref } from '@r-and-a-shared-ui/utils';

export const NextJSLinkWrapper = ({
  href,
  children,
  isExternal,
  openInNewTab,
  prefix,
  prefetch,
  className,
  role,
  kontentItemId,
}: {
  href: string;
  children: ReactNode;
  isExternal?: boolean;
  openInNewTab?: boolean;
  prefix?: string;
  prefetch?: boolean;
  className?: string;
  role?: string;
  kontentItemId?: string;
}) => {
  // always cleaning up the href
  const parsedHref = getParsedHref(!isExternal, href) ?? href;

  return openInNewTab ? (
    <a
      data-testid={'LinkWrapper'}
      href={parsedHref}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      role={role}
      data-kontent-item-id={kontentItemId}
    >
      {children}
    </a>
  ) : (
    <Link
      data-testid={'LinkWrapper'}
      prefetch={prefetch}
      href={
        prefix !== '' && prefix !== undefined
          ? '/' + prefix + parsedHref
          : parsedHref
      }
      className={className}
      role={role}
      data-kontent-item-id={kontentItemId}
    >
      {children}
    </Link>
  );
};
